import React from 'react'


const ChangePassword = () => {
    return (
        <>
            <div className='header'>
                <h3>تغییر رمز عبور</h3>
            </div>
            <div className='body-change-password'>
                change password
            </div>
        </>
    )
}


export default ChangePassword